<template>
	<div class="box">
		<p v-if="selectedGroup" style="margin-bottom: 2rem">
			<a class="has-text-link is-flex is-flex-vcenter" @click.prevent="selectGroup(null)">
				<span class="icon is-small has-text-link">
					<font-awesome-icon :icon="['far', 'angle-left']"></font-awesome-icon>
				</span>
				<span style="margin-left: 0.5rem">Back to All Chances</span>
			</a>
		</p>

		<div class="table-scroll-container">
			<div class="table-scroll">
				<table class="table">
					<thead>
						<tr v-if="!selectedGroup">
							<th class="has-border-right">Chance to get...</th>
							<template v-for="(group, i) in chances.groups">
								<th
									class="has-text-right"
									:class="{'has-border-right': i + 1 < chances.groups.length}"
								>
									<a v-if="group.positions.length > 1" class="has-text-link effect" @click.prevent="selectGroup(group)">{{ group.name }}</a>
									<span v-else>{{ group.name }}</span>
								</th>
							</template>
						</tr>
						<tr v-else>
							<th class="has-border-right">Chances for {{ selectedGroup.name }}</th>
							<template v-for="position in selectedGroup.positions">
								<th class="has-text-right has-border-right">
									#{{ position + 1 }}
								</th>
							</template>
						</tr>
					</thead>
					<tbody>
						<template v-for="team in chances.teams">
							<tr>
								<td class="has-border-right clickable" @click.prevent.stop="selectTeam(selectedTeam == team ? null : team)">
									<div class="is-flex is-flex-apart is-flex-vcenter">
										<TeamLink :teamKey="team.key" :teamName="team.name" />
										<span class="icon is-small has-text-link">
											<font-awesome-icon :icon="['far', selectedTeam == team ? 'angle-up' : 'angle-down']"></font-awesome-icon>
										</span>
									</div>
								</td>
								<template v-for="(group, i) in team.group_chances">
									<template v-if="selectedGroup">
										<template v-if="chances.groups.indexOf(selectedGroup) == i">
											<td v-for="position in selectedGroup.positions" class="has-text-right has-border-right">{{ team.position_chances[position] }}</td>
										</template>
									</template>
									<template v-else>
										<td class="has-text-right" :class="{'has-border-right': i + 1 < team.group_chances.length}">{{ group.chance }}</td>
									</template>
								</template>
							</tr>
							<template v-if="selectedTeam == team">
								<tr v-for="(wins, w) in chances.possible_wins" class="is-secondary">
									<td class="has-border-right" style="padding-left: 2rem">...with {{ wins }} more win{{ wins == 1 ? "" : "s" }}</td>
									<template v-for="(group, i) in team.group_chances">
										<template v-if="selectedGroup">
											<template v-if="chances.groups.indexOf(selectedGroup) == i">
												<td v-for="position in selectedGroup.positions" class="has-text-right has-border-right">{{ team.position_win_chances[position].win_chances[w] }}</td>
											</template>
										</template>
										<template v-else>
											<td class="has-text-right" :class="{'has-border-right': i + 1 < team.group_chances.length}">{{ group.win_chances[w] }}</td>
										</template>
									</template>
								</tr>
							</template>
						</template>
					</tbody>
				</table>
			</div>
		</div>

		<p v-if="chances.type == 'simulated'" style="margin-top: 2rem">
			<small
				>These chances were calculated by simulating the remaining matchups based on each team's average points and standard
				deviation of points.<br />The simulation was ran 10,000 times to get an average of the results.</small
			>
		</p>
	</div>
</template>

<script>
import TeamLink from "@/components/TeamLink"

export default {
	components: {
		TeamLink,
	},
	props: {
		chances: {
			type: Object,
			default: () => null,
		},
	},
	data() {
		return {
			selectedGroup: null,
			selectedTeam: null,
		}
	},
	methods: {
		selectGroup(group) {
			this.selectedGroup = group
		},
		selectTeam(team) {
			this.selectedTeam = team
		}
	}
}
</script>

<style scoped>
.clickable {
	cursor: pointer;
}
</style>
